module.exports = __webpack_public_path__ + "static/media/Blog-1.2521d4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Home/Blog-1.jpg
// module id = 152
// module chunks = 0